export default __webpack_public_path__ + "static/media/graspop.e7724889.jpg";